import type { FC } from "react";

type SkeletonProps = {
  className?: string;
};

/** Base pulse placeholder used by view skeletons. */
const Skeleton: FC<SkeletonProps> = ({ className = "" }) => (
  <div className={`animate-pulse bg-white ${className || "rounded-md"}`.trim()} aria-hidden />
);

export default Skeleton;
